<template>
    <QuillEditor ref="editor" class="editor" theme="snow" toolbar="#custom-toolbar" @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)" @ready="onEditorReady($event)" @change="onEditorChange($event)"
        @update:content="updateFromEditor" v-model:content="content" content-type="html">
        <template #toolbar>
            <div id="custom-toolbar">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
            </div>
        </template>
    </QuillEditor>
</template>

<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import { toRef } from 'vue'

export default {
    name: 'quill-editor',
    components: {
        QuillEditor
    },
    props: ['message'],
    setup(props, ctx) {
        const content = toRef(props, 'message') //TODO: modify
        const updateFromEditor = (contents) => {
            //console.info("update:", contents)
            ctx.emit('update', contents)
        }
        const onEditorBlur = (quill) => {
            console.log('editor blur!', quill)
        }
        const onEditorFocus = (quill) => {
            console.log('editor focus!', quill)
        }
        const onEditorReady = (quill) => {
            console.log('editor ready!', quill)
        }
        const onEditorChange = ({ quill, html, text }) => {
            console.log('editor change!', quill, html, text)
        }
        return { content, updateFromEditor, onEditorBlur, onEditorFocus, onEditorReady, onEditorChange }

    }
}
</script>

<style scoped>
.editor {
    /* width: 100%;
    max-width: 1400px; */
    width: 50%;
    height: 0.7vh;
}
</style>